export const getDeviceInfo = () => {
  const screenWidth = window.innerWidth;
  const phoneWidth = 500;
  const isPhone = screenWidth <= phoneWidth;
  const isDesktop = !isPhone;
  return { isDesktop, isPhone };
};
